import Palette from "./Palette";
import Canvas from "./Canvas";
import Inspector from "./Inspector";

// Build mode 3-column layout (.fb-grid in formBuilder.css)
export default function Builder({
  form,
  selectedId,
  setSelectedId,
  addField,
  removeField,
  moveField,
  updateField,
  setStrict,
}) {
  const selected = form?.fields?.find((f) => f.id === selectedId) || null;

  return (
    <div className="fb-grid">
      <Palette onAdd={addField} />

      <Canvas
        fields={form.fields}
        selectedId={selectedId}
        onSelect={setSelectedId}
        onRemove={removeField}
        onAdd={addField}
        onMove={moveField}
      />

      <div className="card shadow-sm">
        <div className="card-header py-2 small fw-semibold text-secondary text-uppercase">
          Field settings
        </div>
        <div className="card-body p-3">
          <Inspector field={selected} updateField={updateField} />
          <div className="form-check mt-3 pt-3 border-top">
            <input
              className="form-check-input"
              type="checkbox"
              id="fb-strict"
              checked={form.strict}
              onChange={(e) => setStrict(e.target.checked)}
            />
            <label
              className="form-check-label small text-secondary"
              htmlFor="fb-strict"
            >
              Strict — reject fields not in this form
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
